import React from "react";

const Location = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M5 17l-3 6h20l-3-6" />
      <path d="M19 8c0 4.32-7 11.375-7 11.375S5 12.32 5 8c0-4.43 3.617-7 7-7s7 2.57 7 7z" />
      <circle cx={12} cy={8} r={2} />
    </g>
  </svg>
);

export default Location;



// WEBPACK FOOTER //
// ./src/theme/icons/Location.js